import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { AiOutlineEye } from 'react-icons/ai';
import { BsFileEarmarkText } from 'react-icons/bs';
import { FiDownload } from 'react-icons/fi';
import { IoClose } from 'react-icons/io5';

const Facturas = ({ documents = [], onView, onDownload, onDelete }) => {
  const { t } = useTranslation(['backoffice']);

  return (
    <section className="order-documents-section" data-testid="order-facturas">
      <div className="order-documents-section__header">
        <h3 className="order-documents-section__title">{t('facturas')}</h3>
        <span className="order-documents-section__count">
          {t('orderTrans.facturasCount', { count: documents.length })}
        </span>
      </div>

      <div className="order-documents-section__list border-grey store-pickup-box">
        {documents.length === 0 ? (
          <p className="order-documents-section__empty text-light mb-0">{t('orderTrans.noDocuments')}</p>
        ) : (
          documents.map((doc, index) => (
            <div
              key={doc.id}
              className={`order-doc-row ${index < documents.length - 1 ? 'order-doc-row--bordered' : ''}`}
            >
              <div className="order-doc-row__info d-flex align-items-center gap-3 flex-grow-1 min-w-0">
                <BsFileEarmarkText className="order-doc-row__icon flex-shrink-0" />
                <div className="min-w-0">
                  <p className="order-doc-row__name text-light mb-0 text-truncate">{doc.name}</p>
                  <p className="order-doc-row__meta mb-0">{doc.meta}</p>
                </div>
              </div>

              <div className="order-doc-actions d-flex align-items-center gap-2 flex-shrink-0">
                <button type="button" className="order-doc-btn" onClick={() => onView(doc)}>
                  <AiOutlineEye />
                  <span>{t('orderTrans.viewDocument')}</span>
                </button>
                <button type="button" className="order-doc-btn" onClick={() => onDownload(doc)}>
                  <FiDownload />
                  <span>{t('orderTrans.downloadDocument')}</span>
                </button>
                <button
                  type="button"
                  className="order-doc-delete-btn"
                  aria-label={t('delete')}
                  onClick={() => onDelete(doc.id)}
                >
                  <IoClose />
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </section>
  );
};

Facturas.propTypes = {
  documents: PropTypes.array,
  onView: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default Facturas;
